module.exports = __webpack_public_path__ + "media/images/icons/icons_small/24_cake2-646fed783d365fa9be4b04be3d5a5efb.png";